/**
 * The affiliate notice offering a professionally-printed card.
 *
 * Shown beside both places the print-ready PDF can be downloaded
 * (`credential-panel.js` and `dashboard.js`'s print dialog), so a family who wants
 * proper cards rather than their own printer sees the option at the moment it is
 * relevant, without it appearing on the public retrieval page.
 *
 * Kept out of `patterns.js`: that module holds generic, content-free UI patterns,
 * and this one names a specific partner and carries a legally-required disclosure,
 * so its wording lives in one place rather than being duplicated at each call site.
 *
 * **Not a themed `wa-callout` variant.** As with the emergency notice, this brand's
 * palette maps "warning" to green and "danger" to gold, neither of which suits a
 * commercial notice — so no `variant` is set, leaving a neutral box.
 */

import { el, icon } from "./dom.js";
import { PRINT_PARTNER_NAME, PRINT_PARTNER_URL } from "../config/print-partner.js";

/**
 * @returns {HTMLElement}
 */
export function printPartnerNotice() {
  return el("wa-callout", { class: "kin-alert kin-print-partner" }, [
    icon("print"),
    el("div", {}, [
      el("p", { class: "kin-prose" }, [
        "Want proper printed cards instead of using your own printer? ",
        el(
          "a",
          {
            href: PRINT_PARTNER_URL,
            target: "_blank",
            rel: "noopener noreferrer",
          },
          [`Order cards from ${PRINT_PARTNER_NAME}`],
        ),
        " using the file you download here.",
      ]),
      el("p", { class: "kin-note" }, [
        `Affiliate link — KinCode may earn a small commission if you order through it. ` +
          `You'll deal directly with ${PRINT_PARTNER_NAME} under its own terms; we don't ` +
          `send them anything you haven't chosen to share.`,
      ]),
    ]),
  ]);
}
